<template>
  <Card>
    <CardHeader>
      <CardTitle>Details</CardTitle>
    </CardHeader>
    <CardContent>
      <p><strong>Address:</strong> {{ address }}</p>
      <p v-if="phoneNumber"><strong>Phone:</strong> {{ phoneNumber }}</p>
      <p v-if="website">
        <strong>Website:</strong>
        <a :href="website" target="_blank" class="text-blue-500 hover:underline">{{ website }}</a>
      </p>
      <p v-if="priceRange"><strong>Price Range:</strong> {{ formatPriceRange(priceRange) }}</p>
      <p v-if="rating"><strong>Rating:</strong> {{ rating }} ({{ ratingCount }} reviews)</p>
      <slot />
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

defineProps<{
  address: string
  phoneNumber?: string
  website?: string
  priceRange?: string
  rating?: number
  ratingCount?: number
}>()

const formatPriceRange = (priceRange: string) => {
  const priceMap: { [key: string]: string } = {
    PRICE_LEVEL_FREE: 'Free',
    PRICE_LEVEL_INEXPENSIVE: '$',
    PRICE_LEVEL_MODERATE: '$$',
    PRICE_LEVEL_EXPENSIVE: '$$$',
    PRICE_LEVEL_VERY_EXPENSIVE: '$$$$',
  }
  return priceMap[priceRange] || priceRange
}
</script>
